import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: '',
  message: '',
  primaryButtonText: '',
  secondaryButtonText: '',
  onSuccessCallback: null,
  onErrorCallback: null,
  //onSubmit: () => {},
  open: false
}

const dialogSlice = createSlice({
  name: 'dialog',
  initialState: initialState,
  reducers: {
    openDialog: (state, action) => {
      const {
        title = "",
        message = "",
        primaryButtonText = "",
        secondaryButtonText = "",
        onSuccessCallback = null,
        onErrorCallback = null,
        //onSubmit = () => { },
        open = true
      } = action.payload;
      state.title = title
      state.message = message
      state.primaryButtonText = primaryButtonText
      state.secondaryButtonText = secondaryButtonText
      state.onSuccessCallback = onSuccessCallback
      state.onErrorCallback = onErrorCallback
      //state.onSubmit = onSubmit
      state.open = open
    },
    closeDialog: (state) => {
      state.open = false;
    }
  },
});

export const { closeDialog, openDialog } = dialogSlice.actions;

export default dialogSlice.reducer;

export const selectDialog = state => state.snack;
